<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="http://drive.google.com/uc?export=view&id=1z9kN80QO5ZKCtM_7ZhcaLHjPF2fwzKzT" width="50" height="50"  alt="CoreUI Logo" />
        <img
          class="navbar-brand-minimized"
          src="img/logo-symbol1.png"
          width="30"
          height="30"
          alt="CoreUI Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownNotif />
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" />
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body" id="appbody">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed v-if="role_id != 6">
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://www.treboljuridico.com/">Trebol Jurídico</a>
        <span class="ml-1">&copy; 2022.</span>
      </div>

      <div class="ml-auto">
        <span class="mr-1">
          Software en versión beta (Pruebas) haga clic
          <a
            href="https://forms.gle/g4EBD7aEE6NouKAY9"
            target="_blank"
            class="text-danger"
          >
            <b>aquí</b>
          </a> para reportar un error.
        </span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import DefaultHeaderDropdownNotif from "./DefaultHeaderDropdownNotif";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    DefaultHeaderDropdownNotif,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      nav: [],
      nav_: nav.items,
      //nav: JSON.parse(localStorage.getItem('options'))
      isCustomer: false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  created() {
    var auth = localStorage.getItem("auth");
    auth = JSON.parse(auth);
    let role = auth[0].role_id;

    console.log('Rol ID:::::::::', this.role_id);

    // ROLES EXISTENTES
    // 1 => Administrador
    // 2 => Comercial
    // 3 => Gestor de tasa de intereses
    // 4 => Prejuridico
    // 5 => Jurídico
    // 6 => Cliente
    // 7 => Gerente comercial
    // 8 => Gerente prejuridico
    // 9 => Gerente jurídico

    if (role === 4 || role == 8) {
      // DEUDOR
      this.nav = [];
      for (let i = 0; i < this.nav_.length; i++) {
        const item = this.nav_[i];
        if (item.name !== "CUENTAS")
          if (item.name !== "AJUSTES")
            if (item.name !== "INFORMES")
              if (item.name !== "CAMPAÑAS")
                if (item.name !== "CALENDARIO") this.nav.push(item);

        if (item.name === "INDICADORES") {
          var child = [];
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            if (children.name === "PREJURÍDICO") child.push(children);
          }

          item.children = child;
        }
      }

    } else if (role === 5) {
      // JURIDICO
      this.nav = [];
      for (let i = 0; i < this.nav_.length; i++) {
        const item = this.nav_[i];

        if (item.name !== "CUENTAS")
          if (item.name !== "INFORMES")
            if (item.name !== "CAMPAÑAS")
              if (item.name !== "AJUSTES")
                if (item.name !== "CARTAS") this.nav.push(item);

        if (item.name === "CALENDARIO") {
          var child = [];
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            if (children.name === "ACTIVIDADES") child.push(children);
          }
          item.children = child;
        }

        if (item.name === "INDICADORES") {
          var child = [];
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            if (children.name === "JURÍDICO") child.push(children);
          }

          item.children = child;
        }

        if (item.name === "EXPORTACIÓN") {
          var child = [];
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            if (children.name === "JURÍDICO") child.push(children);
          }

          item.children = child;
        }
      }

    } else if (role === 2 || role === 7) {
      // COMERCIAL
      this.nav = [];

      for (let i = 0; i < this.nav_.length; i++) {
        const item = this.nav_[i];

        if (
          item.name === "PANEL DE CONTROL" ||
          item.name === "CUENTAS" ||
          item.name === "DEUDORES" ||
          item.name === "INDICADORES" ||
          item.name === "CALENDARIO"
        )
          this.nav.push(item);

        if (item.name === "INDICADORES") {
          var child = [];
          // console.log(item.children);
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            // console.log(children.name);

            if (children.name === "COMERCIAL") {
              // console.log("Entró");
              child.push(children);
            }
          }

          // console.log(child);
          item.children = child;
          console.log(item);
        }
      }

    } else if (role === 6) {
      // CLIENTE
      this.nav = [];
      for (let i = 0; i < this.nav_.length; i++) {
        const item = this.nav_[i];

        if (item.name !== "CUENTAS")
          if (item.name !== "INFORMES")
            if (item.name !== "CAMPAÑAS")
              if (item.name !== "AJUSTES")
                if (item.name !== "CALENDARIO")
                  if (item.name !== "INDICADORES")
                    if (item.name !== "CARTAS")
                      if (item.name !== "EXPORTACIÓN") this.nav.push(item);
      }

      this.nav.push({
        title: false,
        name: "ANÁLISIS DE CARTERA",
        url: "/debtorindicators",
        icon: "icon-puzzle",
      });
    }
    else if (role == 9) {
      // JURIDICO
      this.nav = [];
      for (let i = 0; i < this.nav_.length; i++) {
        const item = this.nav_[i];

        if (item.name !== "CUENTAS")
          if (item.name !== "AJUSTES")
            if (item.name !== "INFORMES")
              if (item.name !== "CAMPAÑAS")
                if (item.name !== "CARTAS") this.nav.push(item);

        if (item.name === "CALENDARIO") {
          var child = [];
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            if (children.name === "ACTIVIDADES") child.push(children);
          }

          item.children = child;
        }

        if (item.name === "INDICADORES") {
          var child = [];
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            if (children.name === "JURÍDICO") child.push(children);
          }

          item.children = child;
        }

        if (item.name === "EXPORTACIÓN") {
          var child = [];
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            if (children.name === "JURÍDICO") child.push(children);
          }

          item.children = child;
        }

        if (item.name === "AJUSTES") {
          this.nav.push(item);
          var child = [];
          for (let j = 0; j < item.children.length; j++) {
            const children = item.children[j];
            if (children.name === "JUZGADOS") child.push(children);
          }

          item.children = child;
        }
      }

    } else if (role === 1) {
      // ADMINISTRADOR
      this.nav = this.nav_;
    }

    this.nav.push({
      title: false,
      name: "CAMBIAR CONTRASEÑA",
      url: "/password",
      icon: "fa fa-key",
    });
  },
};
</script>
